import { Component, OnInit, ViewChild } from '@angular/core';
import { GlobalService } from 'src/app/global.service';
import { HttpService } from 'src/app/http.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { DistrictService } from '../district.service'
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-district-table',
  templateUrl: './district-table.component.html',
  styleUrls: ['./district-table.component.scss']
})
export class DistrictTableComponent implements OnInit {

  dataSource: any;
  displayedColumns: string[] = ['id', 'name', 'state_name', 'capital', 'district_code'];
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  constructor(private global: GlobalService, private http : HttpService, public service: DistrictService) {
    this.global.set_master_page_title = 'District';
    this.getDistrict();
    this.service.downloadDistrict.subscribe((district) => {
      console.log(district);
      if (district) {
        this.getDistrict();
      }
    });
   }

   getDistrict() {
    this.http.getDistrict().subscribe((data: District[]) => {
      console.log(data);
      this.dataSource = new MatTableDataSource<District>(data);
      this.dataSource.sort = this.sort;
    }, (error) => {
      console.log(error);
    });
  }

  registerDistrict() {
    this.showDistrictRegister();
    this.service.DistrictUpdate.emit(null);
    this.service.set_district_data = null;
  }

  editDistrict(element) {
    this.showDistrictRegister();
    this.service.DistrictUpdate.emit(element);
    this.service.set_district_data = element;
  }

  hideDistrictRegister() {
    this.service.is_display_district_register_component = false;
  }

  showDistrictRegister() {
    this.service.is_display_district_register_component = true;
  }

  ngOnInit() {
  }

}

export interface District {
  id: number;
  name: string;
}